import { Ics2ErrorLevel, Ics2ErrorLocation } from './types';

/** House consignments and their items share a rank; the consignment index separates them. */
const LEVEL_ORDER: Record<Ics2ErrorLevel, number> = {
    master: 0,
    masterItem: 1,
    houseConsignment: 2,
    houseItem: 2,
};

/**
 * Top-down order: the master level, then its items, then each house consignment with its own
 * items. Within a level the errors that belong to the level itself (index 0) come before its
 * goods items. Locations that could not be resolved sort last, keeping whatever order customs
 * reported them in.
 */
export const compareIcs2ErrorLocations = (a?: Ics2ErrorLocation, b?: Ics2ErrorLocation): number => {
    if (!a && !b) return 0;
    if (!a) return 1;
    if (!b) return -1;

    const byLevel = LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
    if (byLevel !== 0) return byLevel;

    const byConsignment = (a.houseConsignmentIndex ?? 0) - (b.houseConsignmentIndex ?? 0);
    if (byConsignment !== 0) return byConsignment;

    return (a.itemIndex ?? 0) - (b.itemIndex ?? 0);
};
